import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { DirectorResponseDeleteCommand } from "../../../../../services/varianceService/commands/DirectorResponseDeleteCommand";
import { useDirectorResponseDeleteMutation } from "../../../../../services/varianceService/variance-api";
import { toggleDirectorResponseDeleteModal } from "../../../../../app/slices/VarianceModuleSlice";

function DirectorResponseDeleteDialog() {
    const dispatch = useAppDispatch();
    const modalOpen = useAppSelector((state) => state.varianceModule.DirectorResponseDeleteModal);
    const selectedResponse = useAppSelector((state) => state.varianceModule.SelectedDirectorResponseForDelete);
    const varianceId = useAppSelector((state) => state.varianceRequest.varianceRequest.id);
    const [deleteResponse] = useDirectorResponseDeleteMutation();

    const confirmDelete = () => {
        if (selectedResponse) {
            let command = new DirectorResponseDeleteCommand(
                varianceId!,
                selectedResponse.directorResponseId
            );
            deleteResponse(command);
        }
    };

    const handleClose = () => {
        dispatch(toggleDirectorResponseDeleteModal(null));
    };

    return (
        <Dialog open={modalOpen} onClose={handleClose}>
            <DialogTitle>Delete Director Response</DialogTitle>
            <DialogContent>
                <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    Are you sure you want to delete this response?
                </Typography>
                {selectedResponse && (
                    <Typography
                        variant="body2"
                        sx={{
                            padding: 2,
                            backgroundColor: "#f5f5f5",
                            borderRadius: 1,
                            fontStyle: "italic",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        "{selectedResponse.text}"
                    </Typography>
                )}
                <Typography variant="caption" color="error" sx={{ marginTop: 2, display: "block" }}>
                    This action cannot be undone.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button
                    onClick={() => { confirmDelete(); handleClose(); }}
                    color="error"
                    variant="contained"
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export { DirectorResponseDeleteDialog };
